export const EmailConfirmationSuccess = {
  extends: 'Flex',
  flow: 'y',
  align: 'center center',
  gap: 'B',
  Icon: {
    name: 'checkmark circle',
    color: 'green',
    size: 'A'
  },
  H3: {
    text: '{{ auth.emailConfirmed.title | polyglot }}',
    margin: '0'
  },
  P: {
    text: '{{ auth.emailConfirmed.body | polyglot }}',
    textAlign: 'center',
    color: 'paragraph',
    maxWidth: 'G'
  },
  SigninButton: {
    extends: ['Button', 'ClickableItem'],
    text: '{{ auth.emailConfirmed.action | polyglot }}',
    margin: 'B 0 0',
    width: '100%',
    onClick: (_, el) => {
      el.router('/signin', el.getRoot())
    }
  }
}
